import { makeStyles } from '@material-ui/core/styles';
import theme from '../theme/booking-theme';

const useCommonStyles = makeStyles({
  notification: {
    color: theme.palette.grey1,
    fontSize: theme.typography.pxToRem(14),
    '& notification-banner::part(content)': {
      fontSize: theme.typography.pxToRem(16),
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(12),
      },
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(14),
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },
    '& notification-banner::part(contentTitle)': {
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(16),
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },
  },
});

export default useCommonStyles;
